import React from "react";
import { Media, ColorAndNcsString } from "../../types/media";
import { useTranslation } from "@coworker/locales";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";

interface ColorAndNcsInputProps {
  media: Media;
  onSave: (newMedia: Media) => void;
}

export const ColorAndNcsInput = ({ media, onSave }: ColorAndNcsInputProps) => {
  const { t } = useTranslation();

  return (
    <FixaInputField
      id={"color_and_ncs"}
      label={t("colorAndNcsString")}
      type="text"
      value={(media as ColorAndNcsString).colorAndNcs ?? ""}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        const newMedia = { ...media };
        (newMedia as ColorAndNcsString).colorAndNcs = newValue;
        onSave(newMedia);
      }}
    />
  );
};
